// extracted by mini-css-extract-plugin
module.exports = {"d17izmww":"d17izmww"};